{
  "schemaVersion": "1.0",
  "status": "DRAFT_DIRECTIONAL",
  "note": "Directional marketing content. Prices are management targets; public-pricing.json must be generated from Pricing Master at publish.",
  "id": "intelligence",
  "order": 2,
  "accent": "aviation-blue",
  "eyebrow": "SHARED INTELLIGENCE",
  "title": "Intelligence",
  "valueStatement": "Connect aircraft context, technical information, parts, and human expertise through trusted AI.",
  "outcome": "Understand. Investigate. Coordinate.",
  "workflow": [
    "Ask",
    "Retrieve",
    "Reason",
    "Cite",
    "Route for review"
  ],
  "intelligenceInContext": {
    "name": "Ask AI · humanIQ · faaIQ · troubleshootingIQ · partsIQ",
    "headline": "Source-grounded answers with citations.",
    "helpsWith": [
      "Answer maintenance questions with citations",
      "Investigate symptoms against history",
      "Find parts and alternates",
      "Look up FAA regulations and ADs"
    ],
    "drawsOn": [
      "Vault",
      "Human Intelligence",
      "Approved knowledge"
    ],
    "humanAuthority": "AI assists. Authorized people decide.",
    "aiUsage": "Billed by credit; Ask AI question ≈ 4 credits."
  },
  "moduleBreakdowns": [
    {
      "moduleId": "vault",
      "iq": [
        "vaultIQ"
      ],
      "helpsWith": [
        "Find any record in seconds",
        "Identify missing or conflicting records",
        "Assemble evidence packages"
      ],
      "humanAuthority": "Record acceptance and corrections stay with records personnel."
    },
    {
      "moduleId": "operate",
      "iq": [
        "complianceIQ"
      ],
      "helpsWith": [
        "Explain why an item is due",
        "Organize AD/SB/LLP evidence",
        "Prepare readiness briefings"
      ],
      "humanAuthority": "Airworthiness and applicability determinations stay with authorized personnel."
    },
    {
      "moduleId": "shop",
      "iq": [
        "shopIQ",
        "shiftIQ"
      ],
      "helpsWith": [
        "Summarize open work for incoming shifts",
        "Surface similar past findings",
        "Flag missing evidence before closeout"
      ],
      "humanAuthority": "Signoff, inspection, and return to service stay with authorized people."
    },
    {
      "moduleId": "forge",
      "iq": [
        "Your Intelligence"
      ],
      "helpsWith": [
        "Run BYOM and co-built intelligence",
        "Host Ironfleet Network partner agents under the same governance"
      ],
      "humanAuthority": "Activation and governance approval stay with the customer."
    }
  ],
  "evidenceProduced": [
    "Cited answers",
    "Curated knowledge",
    "Decision records"
  ],
  "regulatory": {
    "anchors": [
      "ac-120-78b"
    ],
    "included": [
      "Citations and provenance",
      "Role-scoped retrieval"
    ],
    "readinessServices": []
  },
  "pricingId": "intelligence",
  "showExtensions": true
}